import { aroFetch } from "../aroApi";
import { AROEvent, EventListResponse } from "../../types/aro";

export async function fetchEvents(): Promise<EventListResponse> {
  return aroFetch<EventListResponse>("/api/events");
}

export async function createEvent(
  event_name: string,
  start_date: string,
  changed_by: string,
  end_date: string,
  delivery?: string
): Promise<AROEvent> {
  return aroFetch<AROEvent>("/api/events", {
    method: "POST",
    body: JSON.stringify({
      event_name,
      start_date,
      end_date,
      ...(delivery ? { delivery } : {}),
      changed_by,
    }),
  });
}

export async function updateEvent(
  event_id: string | number,
  fields: { event_name?: string; start_date?: string; end_date?: string | null; delivery?: string | null },
  changed_by: string
): Promise<AROEvent> {
  return aroFetch<AROEvent>(`/api/events/${event_id}`, {
    method: "PATCH",
    body: JSON.stringify({ ...fields, changed_by }),
  });
}
